<template>
    <CodiceFeanorView tool-module="hkdf" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
